module.exports = __webpack_public_path__ + "static/media/logo_white.62c31de9.svg";